exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._14e0H9OmKdcx6_Kzq0bovJ{\n    height: 40px;\n    padding: 0;\n    margin: 0;\n    color: inherit;\n    display: inline-block;\n    text-decoration: none;\n    border-style: solid;\n    border-width: 0 0 3px 0;\n    border-color: transparent;\n    text-align: center;\n    cursor: pointer;\n}\n._14e0H9OmKdcx6_Kzq0bovJ:hover, ._14e0H9OmKdcx6_Kzq0bovJ:active, ._14e0H9OmKdcx6_Kzq0bovJ:visited, ._14e0H9OmKdcx6_Kzq0bovJ:focus, ._2WBt-p8alqiKZwNFdSB50x{\n    text-decoration: none;\n}\n._2WBt-p8alqiKZwNFdSB50x{\n    border-color: #122c47;\n}\n._14e0H9OmKdcx6_Kzq0bovJ:hover{\n    background-color: #122c47;\n    color: white;\n}\n._14e0H9OmKdcx6_Kzq0bovJ p{\n    padding: 10px;\n    font-size: 16px;\n    font-weight: 200;\n}", ""]);

// exports
exports.locals = {
	"item": "_14e0H9OmKdcx6_Kzq0bovJ",
	"active": "_2WBt-p8alqiKZwNFdSB50x"
};